import { Membership, ProfileInitResponse, PromoCode, SubscriptionMembership, UserMemberShipStatus, UserProfile } from './../types/profile';
import { PENDING_PURCHASE_SESSION_DB_REF, PROMO_CODE_DB_REF, USER_DB_REF } from "../constants/firestore";
import { UserAuthInfo } from "../types/auth";
import { callCloudFunction, firestoreDocDelete, firestoreDocRead, firestoreDocUpdate, firestoreWrite } from "./common/firebase";
import { IntentCreationResponse, PendingPurchaseSession, ProductWithPrice, PurchaseSession, StripeCustomer } from '../types/stripe';
import { createStripeCustomer, processPayment } from './common/stripe';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { MembershipType } from '../enums/profile';
import { DELETE_USER_CLOUD_FUNCTION } from '../constants/cloudFunctions';

export async function initUserProfile(
  userAuthInfo: UserAuthInfo,
  appDisplayName:string
): Promise<ProfileInitResponse> {
  const userId = userAuthInfo.uid;
  const userSnap = await firestoreDocRead(USER_DB_REF, userId);
  const userProfile: UserProfile | null = userSnap.data() as UserProfile || null;
  if (userProfile) return { userProfile, isRegistration: false };
  const { email,displayName } = userAuthInfo;
  const stripeCustomer = await createStripeCustomer(displayName ?? 'user', email ?? '');
  const newUserProfile = _generateNewUserProfile(userAuthInfo, stripeCustomer,appDisplayName);
  await firestoreWrite(USER_DB_REF, userId, newUserProfile);
  return { userProfile: newUserProfile, isRegistration: true };
}

export async function retrieveUserPendingPurchaseSession(
  userId: string,
): Promise<PendingPurchaseSession | null> {
  const pendingSessionSnap = await firestoreDocRead(PENDING_PURCHASE_SESSION_DB_REF, userId);
  const pendingSession = pendingSessionSnap.data() as PendingPurchaseSession || null;
  return pendingSession;
}

export async function retrieveUserMembershipObj(
  uid: string,
): Promise<Membership> {
  const userProfile = await firestoreDocRead(USER_DB_REF, uid);
  return (userProfile.data() as UserProfile).membership as Membership;
}

export async function writeUserPurchaseSession(
  userId: string,
  session: PendingPurchaseSession,
): Promise<void> {
  await firestoreWrite(PENDING_PURCHASE_SESSION_DB_REF, userId, session);
}

function _generateNewUserProfile(
  userAuthInfo: UserAuthInfo,
  stripeCustomer: StripeCustomer,
  appDisplayName:string
): UserProfile {
  return {
    uid: userAuthInfo.uid,
    tsCreated: Date.now(),
    email: userAuthInfo.email,
    stripeCustomer: stripeCustomer,
    membership: null,
    termsAndConditions: {
      accepted: true,
      tsAccepted: Date.now()
    },
    displayName:appDisplayName
  }
}




export async function checkPromoCodeValidity(
  code: string
): Promise<boolean> {
  const promoCodeDataSnap = await firestoreDocRead(PROMO_CODE_DB_REF, code);
  if (!promoCodeDataSnap.exists()) return false;
  const promoCodeData = promoCodeDataSnap.data() as PromoCode;
  return !promoCodeData.used;
}

export async function deleteAuthUser() {
  const cfRes = await callCloudFunction(DELETE_USER_CLOUD_FUNCTION, null);
  console.log("cf response", cfRes)
  if (!(cfRes.data as any).outcome) throw `[CF ERROR]: ${(!cfRes.data as any).description}`;
  return (cfRes.data as any).data;
}








export async function processUserMembership(
  uid: string,
  stripe: Stripe,
  elements: StripeElements,
  purchaseSession: PurchaseSession,
  onComplete: () => void
): Promise<void> {
  let membershipObject = null;
  //membershipObject = generatePendingSubscriptionMembershipObj(purchaseSession.product, purchaseSession.subscription);
  await processPayment(stripe, elements);
  //await firestoreDocDelete(PENDING_PURCHASE_SESSION_DB_REF, uid);
  onComplete();
}

/* export function generatePendingSubscriptionMembershipObj(
  product: ProductWithPrice,
  subscriptionData: any
): SubscriptionMembership {
  return {
    type: MembershipType.SUBSCRIPTION,
    stripeProductRef: product.id,
    subscriptionData,
  }
} */